"use client"

import * as PortalPrimitive from "@radix-ui/react-portal"

const Portal = PortalPrimitive.Root

export { Portal }
